

import Accounts from "./Accounts";


class Location extends Accounts{
    constructor(params) {
      super(params);
    
    this.accountLabel = "Location";
    this.accountType = "Location";
  this.setParameters(params);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }else{
                this[prop] = params[prop];
              }
              
          }
      }
    }
    setCompany(o){
      this.company = o;
    }
    
}

export default Location;
  